import { render, staticRenderFns } from "./FooterBar.vue?vue&type=template&id=c807187e&"
import script from "./FooterBar.vue?vue&type=script&lang=js&"
export * from "./FooterBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports